import { LOG_APPLICATON_ERROR, CLEAR_APPLICATON_ERROR } from "../../containers/WorkkardDetail/actions/actionConstants";

const initialState = { 
    status:null
};

export default function (state = initialState, action) {
    switch (action.type) {
        case LOG_APPLICATON_ERROR: {
            return Object.assign({}, state, action.payload);
        }
        case CLEAR_APPLICATON_ERROR:
            return initialState;
        default:
            return state;
    }
}
